import React from 'react';
import PropTypes from 'prop-types';

const NavigateRight = ({ fill, theme, ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 7.4C2.66863 7.4 2.4 7.66863 2.4 8C2.4 8.33137 2.66863 8.6 3 8.6L3 7.4ZM13.4243 8.42426C13.6586 8.18995 13.6586 7.81005 13.4243 7.57574L9.60589 3.75736C9.37157 3.52304 8.99167 3.52304 8.75736 3.75736C8.52304 3.99167 8.52304 4.37157 8.75736 4.60589L12.1515 8L8.75736 11.3941C8.52304 11.6284 8.52304 12.0083 8.75736 12.2426C8.99167 12.477 9.37157 12.477 9.60589 12.2426L13.4243 8.42426ZM3 8.6L13 8.6L13 7.4L3 7.4L3 8.6Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

NavigateRight.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default NavigateRight;
